var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x grid-padding-x",attrs:{"id":"provider-list"}},_vm._l((_vm.providers),function(provider,index){return _c('div',{key:index,staticClass:"small-12 medium-4"},[_c('provider-card',{attrs:{"provider":provider},on:{"show-detail":function($event){return _vm.showDetail(provider)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }